import {Grid , Typography  , Stack} from '@mui/material';
import { styled } from '@mui/material/styles';
import { HashLink as Link } from 'react-router-hash-link';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import '../App.css';

function Skills(){

    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 10,
        borderRadius: 5,
        [`&.${linearProgressClasses.colorPrimary}`]: {
          backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        },
        [`& .${linearProgressClasses.bar}`]: {
          borderRadius: 5,
          backgroundColor: theme.palette.mode === 'light' ? 'black' : '#308fe8',
        },
      }));

    return (
        
            <Grid container rowSpacing={1} columnSpacing={{xs : 1 , sm : 1 , md : 1}} style={{marginTop : '4em'}} id="skills">
                <Grid container rowSpacing={2}  columnSpacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="h5" component='div' 
                            style={{textAlign : 'center'}}
                        >
                            Nadir Mesmoudi
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6" component='div' 
                            style={{textAlign : 'center' , color : "#a1a1a1"}}
                        >
                            Front End Web Developer
                        </Typography>
                    </Grid>
                    <Stack  
                        alignItems={'center'} 
                        justifyContent={'center'}
                    > 
                    </Stack>
                            
                        
                    
                    <Grid item xs={12} style={{marginTop : '5em'}}>
                        <Typography variant="h6" component='div' 
                            style={{textAlign : 'center' , color : "#a1a1a1"}}
                        >
                            Short Facts about me 
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container spacing={3} style={{marginLeft : '1em' , marginTop : '5em'}}>
                    <Grid item xs={3} >
                        <Typography style={{fontWeight : 'bold'}}> PROFILE</Typography>
                    </Grid>
                    <Grid item xs={4} >
                        <Typography style={{color : "#a1a1a1"}}>  Front End Web Developer </Typography>
                    </Grid>
                    <Grid item xs={5} >
                        <Typography style={{color : "#a1a1a1"}}> Hi My name is Mohammed Nadir Mesmoudi ,  I am Computer Science student and Front End Web Developer</Typography>
                    </Grid>
                    <Grid item xs={3} >
                        <Typography style={{fontWeight : 'bold'}}>SOCIAL PROFILES</Typography>
                    </Grid>
                    <Grid item xs={4} spacing={2}>
                        <Link to='//www.github.com/nadircode' target='_blank'><GitHubIcon style={{color : '#a89d7c' , marginLeft : '0.5em'}}/></Link>
                        <Link to='//www.linkedin.com/in/nadir-mesmoudi' target='_blank'><LinkedInIcon style={{color : '#a89d7c' , marginLeft : '0.5em'}}/></Link> 
                    </Grid>
                    <Grid item xs={5} >
                        <Typography style={{color : "#a1a1a1"}}> Let me give you a short introduction of myself , with all the keyfacts , if you want to know more about me just further explore this page</Typography>
                    </Grid>
                    <Grid item xs={3} >
                        <Typography style={{fontWeight : 'bold'}}> SKILLS</Typography>
                    </Grid>
                    <Grid item xs={4} rowSpacing={2} style={{position : 'relative'}}>
                        <BorderLinearProgress variant="determinate" value={80}  />
                            <span style={{position: 'absolute' , color : 'white' , marginTop : '-12px', marginLeft : '1em' , fontSize : '10px' , fontWeight : 'bold'}}>HTML5</span>
                            <span style={{position: 'absolute' , color : '#a89d7c' , marginTop : '-12px', marginLeft : '80%' , fontSize : '10px' , fontWeight : 'bold' }}>80%</span>
                        <BorderLinearProgress variant="determinate" value={75} style={{marginTop : '0.5em'}}/>
                            <span style={{position: 'absolute' , color : 'white' , marginTop : '-12px', marginLeft : '1em' , fontSize : '10px' , fontWeight : 'bold'}}>CSS</span>
                            <span style={{position: 'absolute' , color : '#a89d7c' , marginTop : '-12px', marginLeft : '80%' , fontSize : '10px' , fontWeight : 'bold' }}>75%</span>
                        <BorderLinearProgress variant="determinate" value={80} style={{marginTop : '0.5em'}}/>
                            <span style={{position: 'absolute' , color : 'white' , marginTop : '-12px', marginLeft : '1em' , fontSize : '10px' , fontWeight : 'bold'}}>JAVASCRIPT</span>
                            <span style={{position: 'absolute' , color : '#a89d7c' , marginTop : '-12px', marginLeft : '80%' , fontSize : '10px' , fontWeight : 'bold' }}>80%</span>
                        <BorderLinearProgress variant="determinate" value={75} style={{marginTop : '0.5em'}}/>
                            <span style={{position: 'absolute' , color : 'white' , marginTop : '-12px', marginLeft : '1em' , fontSize : '10px' , fontWeight : 'bold'}}>REACT</span>
                            <span style={{position: 'absolute' , color : '#a89d7c' , marginTop : '-12px', marginLeft : '80%' , fontSize : '10px' , fontWeight : 'bold' }}>75%</span>
                        <BorderLinearProgress variant="determinate" value={50} style={{marginTop : '0.5em'}}/>
                            <span style={{position: 'absolute' , color : 'white' , marginTop : '-12px', marginLeft : '1em' , fontSize : '10px' , fontWeight : 'bold'}}>NODE JS</span>
                            <span style={{position: 'absolute' , color : '#a89d7c' , marginTop : '-12px', marginLeft : '80%' , fontSize : '10px' , fontWeight : 'bold' }}>50%</span>
                    </Grid>
                    <Grid item xs={5} >
                        <Typography style={{color : "#a1a1a1"}}>Kind Regards ,</Typography>
                    </Grid>
                    <Grid item xs={4} >
                        <Typography style={{fontWeight : 'bold'}}> CONTACT</Typography>
                    </Grid>
                    <Grid item xs={8} >
                        <Typography style={{color : "#a89d7c" }}> nadir.med.mesmoudi@gmail.com</Typography>
                    </Grid>
                    
                </Grid>
            </Grid>
        
    )
}

export default Skills;